import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Stack,
  Avatar,
  Box,
  alpha,
} from '@mui/material';
import { Send as SendIcon } from '@mui/icons-material';

const WorkpaperAssignDialog = ({ 
  open, 
  onClose, 
  onAssign, 
  auditUsers,
  currentAssignee,
  isAssigning = false 
}) => {
  const [selectedUser, setSelectedUser] = useState(currentAssignee || '');

  const handleAssign = () => {
    onAssign(selectedUser);
  };

  // Helper function to get initials
  const getInitials = (name) => {
    if (!name) return '';
    return name
      .split(' ')
      .map(part => part[0])
      .join('')
      .toUpperCase()
      .slice(0, 2); // Ensure only 2 letters
  };

  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: 2,
          width: '400px',
          bgcolor: 'background.paper',
          boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.08)',
          overflow: 'hidden'
        }
      }}
    >
      <Box sx={{ p: 3, pb: 1, borderBottom: '1px solid', borderColor: 'divider' }}>
        <Stack direction="row" alignItems="center" spacing={1.5}>
          <SendIcon sx={{ color: 'primary.main', fontSize: 24 }} />
          <DialogTitle sx={{ 
            p: 0,
            fontSize: '1.25rem',
            fontWeight: 600,
            color: 'text.primary',
            letterSpacing: '-0.01em'
          }}>
            Assign Workpaper
          </DialogTitle>
        </Stack>
      </Box>

      <DialogContent sx={{ p: 3 }}>
        <FormControl fullWidth>
          <InputLabel sx={{ 
            fontSize: '0.875rem',
            color: 'text.secondary'
          }}>
            Assign To
          </InputLabel>
          <Select
            value={selectedUser}
            onChange={(e) => setSelectedUser(e.target.value)}
            label="Assign To"
            size="small"
            sx={{
              '& .MuiSelect-select': {
                fontSize: '0.875rem',
                py: 1.25
              }
            }}
          >
            <MenuItem value="" sx={{ fontSize: '0.875rem' }}>
              <em>None</em>
            </MenuItem>
            {auditUsers.map((user) => (
              <MenuItem key={user.id} value={user.email}>
                <Stack direction="row" alignItems="center" spacing={1}>
                  <Avatar 
                    sx={{ 
                      width: 24, 
                      height: 24, 
                      fontSize: '0.75rem',
                      bgcolor: 'primary.main' 
                    }}
                  >
                    {getInitials(user.fullName)}
                  </Avatar>
                  <Box sx={{ flex: 1, minWidth: 0 }}>
                    <span>{user.fullName}</span>
                  </Box>
                </Stack>
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 3, pt: 1 }}>
        <Button 
          onClick={onClose}
          sx={{ 
            color: 'text.secondary',
            fontWeight: 500,
            px: 2,
            '&:hover': {
              backgroundColor: alpha('#000', 0.04)
            }
          }}
        >
          Cancel
        </Button>
        <Button 
          onClick={handleAssign}
          disabled={!selectedUser || isAssigning}
          variant="contained"
          startIcon={<SendIcon />}
          sx={{ 
            bgcolor: 'primary.main',
            fontWeight: 500,
            px: 2,
            '&:hover': {
              bgcolor: 'primary.dark'
            },
            boxShadow: 'none',
            textTransform: 'none'
          }}
        >
          {isAssigning ? 'Assigning...' : 'Assign'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default WorkpaperAssignDialog; 